import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuszugPrintOptions, AuszugSettingsService } from './auszug-settings-service';
import { FormatConfigService } from '../../../../core/services/format-config.service';
import { RechtPrintOptionsMeta } from '../../../../core/gb-api';
import { AuszugInfoItem, AuszugTypeEnum, FormatEnum } from '../auszug-print-service';
import { ControlValueAccessor, FormsModule, NgForm } from '@angular/forms';
import { ErweiterungConfigResponse } from '../../../../core/base-api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CapAlertService } from '../../../../core/extension/exceptions/cap-alert.service';
import { MetaDirective } from '../../../directives/meta.directive';
import { CapFormColumnsDirective } from '../../../form-control/form-columns.directive';
import { CapFormControlComponent } from '../../../form-control/form-control.component';
import { MetaDisablerDirective } from '../../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../directives/meta-validator.directive';
import { Subscription } from 'rxjs';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

@Component({
  selector: 'cap-rechte-auszug-settings',
  templateUrl: './rechte-auszug-settings.component.html',
  styleUrls: ['./auszug-settings.component.scss'],
  imports: [
    FormsModule,
    MetaDirective,
    TranslatePipe,
    CapFormColumnsDirective,
    CapFormControlComponent,
    MetaDisablerDirective,
    MetaValidatorDirective
  ]
})
export class RechteAuszugSettingsComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @ViewChild(NgForm, { static: false })
  form: NgForm;
  @Input()
  format: FormatEnum;
  @Input()
  title: string;
  @Input()
  auszugItem: AuszugInfoItem;
  @Input()
  ids: Array<string>;
  @Input()
  hasToZip: boolean;
  @Input()
  indexNumber: number;

  auszugType: AuszugTypeEnum = 'Recht';
  public model: RechtPrintOptionsMeta;
  private defaultSettings: RechtPrintOptionsMeta;
  private subscription: Subscription = new Subscription();

  propagateChange: (id: string) => void;
  propagateTouch: (_) => void;
  hasRequiredErweiterung = false;

  constructor(
    public activeModal: NgbActiveModal,
    private auszugSettingsService: AuszugSettingsService,
    private config: FormatConfigService,
    private translateService: TranslateService,
    private alerts: CapAlertService
  ) {
    keysToTranslate<string>(['AufbereitungsoptionenRechteAuszug']);
  }

  ngOnInit(): void {
    this.subscription.add(
      this.config.printConfig$.subscribe((config) => {
        this.defaultSettings = config?.getRechtDefaultSettings();
        this.model = {
          ...config?.getRechtAuszugOptions()
        };
      })
    );
    this.subscription.add(
      this.config.erweiterungsConfig$.subscribe((config) => {
        this.hasRequiredErweiterung = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.GB_AUSZUG_MIT_MEHREREN_GRUNDSTUECKEN);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  confirm() {
    if (!!this.ids && this.ids?.length > 20) {
      this.activeModal.close(true);
      return this.alerts.warning(this.translateService.instant('HinweismeldungAuszuege'));
    }
    const auszugPrintOption = <AuszugPrintOptions>{
      auszugType: this.auszugType,
      printOptions: this.model,
      format: this.format,
      item: this.auszugItem,
      ids: this.ids,
      hasToZip: this.hasToZip,
      indexNumber: this.indexNumber
    };
    this.auszugSettingsService.confirmPrintSelection(auszugPrintOption);
    this.activeModal.close(true);
  }

  resetSettings() {
    this.model = { ...this.defaultSettings };
  }

  writeValue(obj: any): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }
}
